import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useTheme = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');
  return {
    theme: context.theme,
    setTheme: context.setTheme,
  };
};

export { useTheme };
